import React from 'react';
import {defineMessages, FormattedMessage} from 'react-intl';

import * as JoinPromoTypes from 'constants/JoinPromoType';

const messages = defineMessages({
    title: {
        id: 'phone_confirm.title',
        defaultMessage: 'Подтверждение номера телефона'
    },
    successText: {
        id: 'phone_confirm.success',
        defaultMessage: 'Номер {phone} успешно подтвержден!'
    },
    startGameText: {
        id: 'phone_confirm.start_playing',
        defaultMessage: 'Начать игру'
    },
    site146Accepted: {
        id: 'special_offers.site146_accepted',
        defaultMessage: 'Ваш игровой счет принимает участие в акции «Вступительный бонус – 1000 тенге!»'
    }
});

export default class ConfirmSuccess extends React.Component {
    static propTypes = {
        languageId: React.PropTypes.number.isRequired,
        joinPromoType: React.PropTypes.any,
        phone: React.PropTypes.string,
        cancelCallback: React.PropTypes.func.isRequired
    };

    static renderSpecialOffer(joinPromoType) {
        if (joinPromoType === JoinPromoTypes.SITE146) {
            return (<FormattedMessage {...messages.site146Accepted}/>)
        }

        return false;
    }

    render() {
        const {phone, joinPromoType} = this.props;

        return (
            <div className="modal--dialog">
                <div className="modal--header">
                    <div className="header-inner--logotype__link"></div>
                    <div className="header-inner__title">
                        <FormattedMessage {...messages.title}/>
                    </div>
                </div>
                <div className="modal--content">
                    <div className="modal--content__wrapper">
                        <div className="login--form form">
                            <p className="plain-text__paragraph">
                                <FormattedMessage {...messages.successText} values={{phone}}/>
                            </p>
                        </div>
                        {joinPromoType && <div className="login--form form">
                            <p className="plain-text__paragraph">
                                {ConfirmSuccess.renderSpecialOffer(joinPromoType)}
                            </p>
                        </div>}
                        <div className="login--form__row form">
                            <button className="login--form__btn login--form__btn__js form__btn"
                                    onClick={this.props.cancelCallback}>
                                <FormattedMessage {...messages.startGameText} />
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./js/shared/components/PhoneConfirmation/ConfirmSuccess.jsx